import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ApiService } from '@services';
import { flexPassApiParamsSerializer } from '@helpers';

var flexPassSectorsApiConfig = function flexPassSectorsApiConfig(selectedChildIds) {
  if (!(selectedChildIds !== null && selectedChildIds !== void 0 && selectedChildIds.length)) {
    return undefined;
  }

  return {
    params: {
      selectedChildIds: selectedChildIds
    },
    paramsSerializer: flexPassApiParamsSerializer
  };
};

var EventsServiceClass = /*#__PURE__*/function () {
  function EventsServiceClass() {
    _classCallCheck(this, EventsServiceClass);

    _defineProperty(this, "_buyBackCache", undefined);

    _defineProperty(this, "_buyBackShowModal", false);
  }

  _createClass(EventsServiceClass, [{
    key: "getEventById",
    value: function () {
      var _getEventById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(eventSessionUuid) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet("/webapi/event-session/on-show/by-id/".concat(eventSessionUuid), {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getEventById(_x) {
        return _getEventById.apply(this, arguments);
      }

      return getEventById;
    }()
  }, {
    key: "getEventSchemaById",
    value: function () {
      var _getEventSchemaById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(eventSessionUuid) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiGet("/webapi/event-session/svg-scheme/by-id/".concat(eventSessionUuid), {
                  blocked: true,
                  responseType: 'blob'
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getEventSchemaById(_x2) {
        return _getEventSchemaById.apply(this, arguments);
      }

      return getEventSchemaById;
    }()
  }, {
    key: "getEventSectorsListById",
    value: function () {
      var _getEventSectorsListById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(eventSessionUuid, selectedChildIds) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiGet("/webapi/event-session/location-scheme-seats-outgroup/available/by-id/".concat(eventSessionUuid), _objectSpread({
                  blocked: true
                }, flexPassSectorsApiConfig(selectedChildIds))));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getEventSectorsListById(_x3, _x4) {
        return _getEventSectorsListById.apply(this, arguments);
      }

      return getEventSectorsListById;
    }()
  }, {
    key: "getSectorPlacesById",
    value: function () {
      var _getSectorPlacesById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(eventSessionUuid, sectorId, selectedChildIds) {
        var flex, requestParams;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                flex = flexPassSectorsApiConfig(selectedChildIds);
                requestParams = {
                  locationSchemeSeatOutgroupId: sectorId
                };

                if (selectedChildIds !== null && selectedChildIds !== void 0 && selectedChildIds.length) {
                  requestParams.selectedChildIds = selectedChildIds;
                }

                return _context4.abrupt("return", ApiService.apiGet("/webapi/event-session/location-scheme-seats/by-id/".concat(eventSessionUuid), _objectSpread({
                  blocked: true,
                  params: requestParams
                }, flex !== null && flex !== void 0 && flex.paramsSerializer ? {
                  paramsSerializer: flex.paramsSerializer
                } : {})));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getSectorPlacesById(_x5, _x6, _x7) {
        return _getSectorPlacesById.apply(this, arguments);
      }

      return getSectorPlacesById;
    }()
  }, {
    key: "getSectorImagesById",
    value: function () {
      var _getSectorImagesById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sectorId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiGet("/webapi/location-scheme-seats-outgroup-picture/all/by-outgroup/".concat(sectorId), {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getSectorImagesById(_x8) {
        return _getSectorImagesById.apply(this, arguments);
      }

      return getSectorImagesById;
    }()
  }, {
    key: "getSectorPlacesCategoriesById",
    value: function () {
      var _getSectorPlacesCategoriesById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(eventSessionUuid, selectedChildIds) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", ApiService.apiGet("/webapi/event-session/prices/by-id/".concat(eventSessionUuid), _objectSpread({
                  blocked: true
                }, flexPassSectorsApiConfig(selectedChildIds))));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getSectorPlacesCategoriesById(_x9, _x10) {
        return _getSectorPlacesCategoriesById.apply(this, arguments);
      }

      return getSectorPlacesCategoriesById;
    }()
  }, {
    key: "getSectorPlacesLabelsById",
    value: function () {
      var _getSectorPlacesLabelsById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(sectorId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", ApiService.apiGet("/webapi/location-scheme-seats-outgroup-label/all/by-outgroup/".concat(sectorId), {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getSectorPlacesLabelsById(_x11) {
        return _getSectorPlacesLabelsById.apply(this, arguments);
      }

      return getSectorPlacesLabelsById;
    }()
    /** Состав абонемента FLEX_PASS: возвращает пул дочерних сессий для выбора пиков. */

  }, {
    key: "getFlexPassPool",
    value: function () {
      var _getFlexPassPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(eventSessionUuid) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", ApiService.apiGet("/webapi/event-session/flex-pass-pool/by-id/".concat(eventSessionUuid), {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function getFlexPassPool(_x12) {
        return _getFlexPassPool.apply(this, arguments);
      }

      return getFlexPassPool;
    }()
    /** discountPercent по выбранным дочерним сессиям FLEX_PASS. Не усреднять на фронте. */

  }, {
    key: "getFlexPassDiscount",
    value: function () {
      var _getFlexPassDiscount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(eventSessionUuid, request) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", ApiService.apiPost("/webapi/event-session/flex-pass-discount/by-id/".concat(eventSessionUuid), request, {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getFlexPassDiscount(_x13, _x14) {
        return _getFlexPassDiscount.apply(this, arguments);
      }

      return getFlexPassDiscount;
    }()
  }, {
    key: "getAllEvents",
    value: function () {
      var _getAllEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", ApiService.apiGet('/webapi/event-session/on-show/all', {
                  blocked: false
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function getAllEvents() {
        return _getAllEvents.apply(this, arguments);
      }

      return getAllEvents;
    }()
  }, {
    key: "getSectorSeatViews",
    value: function () {
      var _getSectorSeatViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", ApiService.apiGet('/webapi/seatview/all', {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function getSectorSeatViews() {
        return _getSectorSeatViews.apply(this, arguments);
      }

      return getSectorSeatViews;
    }()
  }, {
    key: "getSectorBuyBack",
    value: function () {
      var _getSectorBuyBack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(eventSessionUuid) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", ApiService.apiGet("/webapi/event-session/location-scheme-seats/by-id/".concat(eventSessionUuid, "/buy-back"), {
                  blocked: true
                }));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function getSectorBuyBack(_x15) {
        return _getSectorBuyBack.apply(this, arguments);
      }

      return getSectorBuyBack;
    }()
  }, {
    key: "setBuyBackCache",
    value: function setBuyBackCache(cache) {
      this._buyBackCache = cache;
    }
  }, {
    key: "getBuyBackCache",
    value: function getBuyBackCache() {
      return this._buyBackCache;
    }
  }, {
    key: "setBuyBackShowModal",
    value: function setBuyBackShowModal(show) {
      this._buyBackShowModal = show;
    }
  }, {
    key: "getBuyBackShowModal",
    value: function getBuyBackShowModal() {
      return this._buyBackShowModal;
    }
  }]);

  return EventsServiceClass;
}();

var EventsService = new EventsServiceClass();
export { EventsService };